import * as RadixTabs from '@radix-ui/react-tabs';
import { clsx } from 'clsx';
import type { ReactNode } from 'react';

export interface TabItem {
  value: string;
  label: ReactNode;
  badge?: ReactNode;
  content: ReactNode;
}

export interface TabsProps {
  value: string;
  onValueChange: (v: string) => void;
  items: TabItem[];
  className?: string;
}

export function Tabs({ value, onValueChange, items, className }: TabsProps) {
  return (
    <RadixTabs.Root
      value={value}
      onValueChange={onValueChange}
      className={clsx('flex flex-col', className)}
    >
      <RadixTabs.List className="flex border-b border-line">
        {items.map((it) => (
          <RadixTabs.Trigger
            key={it.value}
            value={it.value}
            className={clsx(
              'inline-flex items-center gap-2 px-3.5 py-2.5 text-sm font-semibold',
              'text-fg-secondary border-b-2 border-transparent -mb-px',
              'hover:text-fg-primary transition-colors duration-fast',
              'data-[state=active]:text-accent data-[state=active]:border-accent',
              'focus-visible:outline-none focus-visible:text-accent',
            )}
          >
            {it.label}
            {it.badge != null && <span className="ml-1">{it.badge}</span>}
          </RadixTabs.Trigger>
        ))}
      </RadixTabs.List>
      {items.map((it) => (
        <RadixTabs.Content key={it.value} value={it.value} className="pt-4 focus-visible:outline-none">
          {it.content}
        </RadixTabs.Content>
      ))}
    </RadixTabs.Root>
  );
}
